import { CallbackPage } from '@shared/auth';
import { useNavigate } from 'react-router-dom';

export function SignInCallbackPage() {
  const navigate = useNavigate();

  return (
    <CallbackPage
      onComplete={(state) => {
        window.sessionStorage.removeItem('pmi.payments.nt');
        navigate(
          state
            ? {
                pathname: state.pathname,
                search: state.search,
                hash: state.hash,
              }
            : { pathname: '/' },
          { replace: true },
        );
      }}
      onFailure={() => navigate('/error', { replace: true })}
    />
  );
}
